/**
 * devLogger - Helper defensivo para imprimir mensajes en consola solo en entorno de desarrollo.
 *
 * Este logger encapsula los métodos estándar de consola (`info`, `warn`, `error`)
 * y los ejecuta únicamente si la bandera `API.DEVELOP` está activa.
 *
 * Uso típico:
 *   devLogger.info("Cargando filtros...");
 *   devLogger.warn("Filtro vacío, usando fallback.");
 *   devLogger.error("Error al guardar filtros", error);
 *
 * Ideal para trazabilidad técnica, debugging y auditoría visual sin contaminar producción.
 */

import { DEVELOP } from '../api';

export const devLogger = {
  /**
   * Imprime un mensaje informativo en consola si `API.DEVELOP` está activo.
   * @param {string} msg - Mensaje a mostrar.s
   */
  info: (msg) => {
    if (DEVELOP) console.info(`[INFO] ${msg}`);
  },

  /**
   * Imprime una advertencia en consola si `API.DEVELOP` está activo.
   * @param {string} msg - Mensaje de advertencia.
   */
  warn: (msg) => {
    if (DEVELOP) console.warn(`[WARN] ${msg}`);
  },

  /**
   * Imprime un error en consola si `API.DEVELOP` está activo.
   * @param {string} msg - Mensaje de error.
   * @param {any} err - Objeto de error o detalle adicional.
   */
  error: (msg, err) => {
    if (DEVELOP) console.error(`[ERROR] ${msg}`, err);
  },
};